import fetchApi from "../fetchApi";
import {DEFAULT_LIMIT} from "../../contstants";

export const GetOffices = async (
    {
        limit = DEFAULT_LIMIT,
        offset = 0,
        status = true,
        name = ''
    }
) => {

    const options = {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        redirect: 'follow'
    }

    return await fetchApi(`offices?limit=${limit}&offset=${offset}&status=${status}&name=${name}`, options);
}